import apiHandler from "../../core/apiHandler";

const inventoryAdjustmentDetailApi = apiHandler(
    'inventory/adjustments/details'
);

export default inventoryAdjustmentDetailApi;
